import { ArrowLeft } from "lucide-react";
import { Button, ScrollArea, cn } from "web-design-system";

interface Props {
  title: string;
  onBack?: () => void;
  children: React.ReactNode;
  action?: React.ReactNode;
  alignCenter?: boolean;
  secondaryAction?: React.ReactNode;
}

export default function MandateLayout(props: Props) {
  const { title, onBack, children, action } = props;

  return (
    <div className={cn("flex flex-col w-full overflow-hidden gap-4")}>
      <ScrollArea className="flex-1 pb-4">
        <div className="flex flex-col flex-1">
          <div className="flex mx-4 px-1 py-4 pb-2 sticky z-10 border-b border-border bg-background top-0 items-center gap-3">
            {onBack && (
              <Button variant="ghost" size="icon" onClick={onBack}>
                <ArrowLeft />
              </Button>
            )}
            <h5 className="text-lg mr-auto font-semibold">{title}</h5>
            {props.secondaryAction}
          </div>

          <div className="px-5 py-4 w-full flex flex-1 flex-col items-center justify-center">
            {children}
          </div>

          {action && (
            <div className="w-full px-5 pt-4 mt-auto bg-popover sticky bottom-0">
              {action}
            </div>
          )}
        </div>
      </ScrollArea>
    </div>
  );
}
